import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	one: [],
	create: [],
	update: []
};

const getEmploisInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_EMPLOIS_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'GET_EMPLOI_RETURN':
			return Object.assign({}, state, {one: action.payload});

		case 'PUT_EMPLOI_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Annonce mise à jour !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				one: action.payload
			});
		case 'DEL_EMPLOI_SAGAS':
			const pas = state.infos.data.items;
			const indexPa = pas.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: pas.filter((item, i) => i !== indexPa)};

			return Object.assign({}, state, {infos: newStateDelete});
		case 'DEL_EMPLOI_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Annonce supprimé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getEmploisInfos;
